import { TFunction } from 'i18next';
import _ from 'lodash';
import {
  ItemSetMetric,
  ItemSetMetricDescriptorBase,
} from './itemSetMetric.types';

export const getItemSetMetricDescriptors = (
  t: TFunction<'app'>,
): ItemSetMetricDescriptorBase[] => [
  // Item
  {
    type: 'consignee',
    path: 'consignee',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'consigneeSku',
    path: 'sku',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'skuGroup',
    path: 'skuGroup',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'subGroup',
    path: 'subGroup',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'transportClass',
    path: 'transportClass',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'stockCategory',
    path: 'stockCategory',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'storageClass',
    path: 'storageClass',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'pollutionClass',
    path: 'pollutionClass',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'uom',
    path: 'uom',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'uomWeight',
    path: 'netWeight',
    rangeType: 'distinct-range',
    aggregationFn: 'min',
    sequentialPaletteId: 'elevation-sort',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'uomWeightPow',
    path: 'netWeight',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'uomVolume',
    path: 'volume',
    rangeType: 'distinct-range',
    aggregationFn: 'min',
    sequentialPaletteId: 'elevation-sort',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  {
    type: 'uomMaxStack',
    path: 'maxStack',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'elevation-sort',
    nullValueBucketTitle: t('Unlimited', { ns: 'app' }),
  },
];

export const getItemSetMetricDescriptorsMap = (t: TFunction<'app'>) =>
  _.keyBy(getItemSetMetricDescriptors(t), d => d.type) as Record<
    ItemSetMetric,
    ItemSetMetricDescriptorBase
  >;
